<template>
  <div
    data-qa="lpu_headline"
    class="lpu-headline"
  >
    <h1
      class="text-no-wrap"
      :class="isMobile ? 'text-h5' : 'lpu-headline__title'"
    >
      <span
        data-qa="lpu_headline_lpu_name"
        class="text--text text-wrap"
      >{{ tDynamic(lpu, 'name') }}</span><SoftVersionIcon
        class="ml-3"
        :soft-version="lpu.owner.soft_version"
      />
    </h1>
    <div
      v-if="!isMobile"
      class="lpu-headline__actions"
    >
      <LeaveRateBtn
        :lpu-id="lpu.id"
        :is-closed="lpu.closed"
      />
      <LpuFavouriteBtn
        :lpu-id="lpu.id"
      />
      <LpuShareBtn
        :lpu="lpu"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import LeaveRateBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LeaveRateBtn.vue'
import LpuFavouriteBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuFavouriteBtn.vue'
import LpuShareBtn from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuShareBtn.vue'
import SoftVersionIcon from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/SoftVersionIcon/SoftVersionIcon.vue'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

defineProps<{
  lpu: Lpu
}>()

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
.lpu-headline {
  display: flex;
  column-gap: 40px;
  justify-content: space-between;

  &__title {
    margin: 0;
    font-weight: 400;
    font-size: 36px;
    line-height: 100%;
    letter-spacing: 0%;
  }

  .text-h5 {
    margin: 0;
  }

  &__actions {
    display: flex;
    column-gap: 10px;
    flex-shrink: 0;
  }
}
</style>
